import { createReduxActionTypes } from '../../../utils/actionFactory';

const SET_SELECT_OPTIONS = 'SET_SELECT_OPTIONS';
const SET_REFRESH = 'SET_REFRESH';
const RESET = 'RESET';
const SET_COLUMNS = 'SET_COLUMNS';
const SET_ACTIVE = 'SET_ACTIVE';
const SET_SELECTED_CLIENT = 'SET_SELECTED_CLIENT';

export const actionTypes = createReduxActionTypes('SIMCARDS', [
  SET_REFRESH,
  SET_SELECT_OPTIONS,
  SET_COLUMNS,
  SET_ACTIVE,
  SET_SELECTED_CLIENT,
  RESET
]);

const DEFAULT_STATE = {
  refresh: false,
  selectsOptions: {},
  columns: [],
  active: 'true',
  selectedClient: {
    value: 'ALL',
    label: 'All Clients',
    display_name: 'All Clients'
  }
};

export const reducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case actionTypes[SET_REFRESH]: {
      return { ...state, refresh: action.refresh };
    }
    case actionTypes[SET_SELECT_OPTIONS]: {
      return { ...state, selectsOptions: { ...action.selectsOptions } };
    }
    case actionTypes[SET_COLUMNS]: {
      return { ...state, columns: [...action.columns] };
    }
    case actionTypes[SET_ACTIVE]: {
      return { ...state, active: action.active };
    }
    case actionTypes[SET_SELECTED_CLIENT]: {
      return { ...state, selectedClient: action.selectedClient };
    }
    case actionTypes[RESET]: {
      return { ...DEFAULT_STATE };
    }
    default:
      return state;
  }
};

export const actions = {
  setRefresh: refresh => ({
    type: actionTypes[SET_REFRESH],
    refresh
  }),
  setSelectsOptions: selectsOptions => ({
    type: actionTypes[SET_SELECT_OPTIONS],
    selectsOptions
  }),
  setColumns: columns => ({
    type: actionTypes[SET_COLUMNS],
    columns
  }),
  setActive: active => ({
    type: actionTypes[SET_ACTIVE],
    active
  }),
  setSelectedClient: selectedClient => ({
    type: actionTypes[SET_SELECTED_CLIENT],
    selectedClient
  }),
  resetSimCards: () => ({ type: actionTypes[RESET] })
};
